/**
 * Portal ICAVI - Serviço de domínio: Setores
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import { api } from '../apiClient';
export const setoresServiceMethods = {
    /**
     * Busca lista de setores
     */
    async getSetores() {
        try {
            const response = await api.get('/api/setores');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar setores:', error);
            throw error;
        }
    },
};
